import { useDroppable } from '@dnd-kit/core'

const DroppableZone = ({id, children, ...props}) => {
    const {setNodeRef} = useDroppable({id})

    return (
      <div ref={setNodeRef} {...props}>
          {children}
      </div>
    )
}

export { DroppableZone }
